export const LinkIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="m11.394 9.696-.849-.849.849-.848a2.4 2.4 0 0 0-3.395-3.394l-.848.848-.848-.848.848-.849a3.6 3.6 0 0 1 5.091 5.091zm-1.698 1.697-.848.849A3.599 3.599 0 1 1 3.757 7.15l.848-.849.849.849-.849.848A2.4 2.4 0 1 0 8 11.393l.849-.848zm0-5.94.85.85-4.243 4.241-.85-.848z"
      />
    </svg>
  );
};
